"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameUrl = void 0;
var game_api_1 = require("@l2p/game-api");
var keys_1 = require("../keys");
var react_1 = require("react");
var useMutation_1 = require("../useMutation");
var useGameReport_1 = require("./useGameReport");
var apps_shared_1 = require("@l2p/apps-shared");
var useGameUrl = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var reportGame = (0, useGameReport_1.useGameReport)().reportGame;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        errorAction: function (err) {
            var _a;
            errorAction === null || errorAction === void 0 ? void 0 : errorAction();
            reportGame((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data);
        },
        path: keys_1.GAME_URL,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error, data = _c.data;
    return (0, react_1.useMemo)(function () { return ({
        getGameUrl: function (payload) {
            var _a;
            return mutate(__assign(__assign({}, payload), { returnUrl: window !== undefined ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin : '', platform: breakpoints.mobile || breakpoints.tablet
                    ? game_api_1.GameDeviceTypeEnum.Mobile
                    : game_api_1.GameDeviceTypeEnum.Desktop }));
        },
        isSubmitting: isSubmitting,
        error: error === null || error === void 0 ? void 0 : error['errorCode'],
        data: data,
    }); }, [breakpoints, mutate, isSubmitting, error, data]);
};
exports.useGameUrl = useGameUrl;
